<template>
  <div class="contact-box pc-contact-box" @mouseleave="hideContactModal" :style="{'width': !isShowContact ? '2.4rem' : '15.1rem'}" v-if="!isMobile">
    <div class="contact-btn" @click="toggleContact" v-if="isMobile">
      <span class="iconfont icon-earphone"></span>
    </div>
    <div class="pc-contact-btn" @mouseover="showContactModal" v-else>
      <div class="contact-btn">
        <span class="iconfont icon-earphone"></span>
      </div>
      <span class="contact-txt">联系客服</span>
    </div>
    <!-- pc端弹窗 -->
    <div class="contact-modal" @mouseover="showContactModal" @mouseleave="hideContactModal" v-show="isShowContact">
      <div class="m-row">
        <span class="info">电话：18124185080</span>
        <span class="copy-btn" v-clipboard:copy="'18124185080'" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span>
      </div>
      <div class="m-row">
        <span class="info">微信：Cheedon</span>
        <span class="copy-btn" v-clipboard:copy="'Cheedon'" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span>
      </div>
    </div>
  </div>
  <div class="contact-box mb-contact-box" v-else>
    <div class="contact-btn" @click="toggleContact" v-if="isMobile">
      <span class="iconfont icon-earphone"></span>
    </div>
    <div class="pc-contact-btn" @mouseover="showContactModal" v-else>
      <div class="contact-btn">
        <span class="iconfont icon-earphone"></span>
      </div>
      <span class="contact-txt">联系客服</span>
    </div>
    <!-- 弹窗 -->
    <van-popup v-model="isShow" position="bottom" class="contact-popup">
      <div class="modal">
        <div class="circle-ring">
          <div class="circle-bg">
            <span class="iconfont icon-earphone"></span>
          </div>
        </div>
        <h3>客服</h3>
        <p class="wechat-num" v-clipboard:copy="'Cheedon'" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">微信：Cheedon</p>
        <p class="prompt-msg">有任何问题，请随时联系我～</p>
        <div class="operation-btn">
          <div class="btn" v-clipboard:copy="'Cheedon'" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">
            <!-- <a href="javascript:void(0);" class="copy-btn"> -->
            <div class="copy-btn">
              <img src="@/assets/images/ic-weixin.png" class="icon icon-wechat"/>
            </div>
            <span class="icon-txt">复制微信</span>
          </div>
          <div class="btn">
            <a href="tel:18124185080" class="copy-btn">
              <img src="@/assets/images/ic-phone.png" class="icon icon-phone"/>
            </a>
            <span class="icon-txt">拨打电话</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: 'contact',
  data () {
    return {
      isMobile: false,
      isShow: false,
      isShowContact: false
    }
  },
  created() {
    this.mobileTerminal((data) => {
      this.isMobile = data;
    })
  },
  methods: {
    toggleContact() {
      this.isShow = !this.isShow;
    },
    onCopySuccess() {
      Toast('复制成功');
      // this.$message.success("复制成功")
    },
    onCopyError() {
      Toast('抱歉，复制失败！');
    },
    showContactModal() {
      this.isShowContact = true;
    },
    hideContactModal() {
      this.isShowContact = false;
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width:750px){
  .contact-box{
    width: 2.4rem;
    position: fixed;
  }
  .pc-contact-box{
    // width: 15.1rem;
    height: 6.1rem;
    top: 3rem;
    right: 4rem;
    z-index: 5;
  }
  .mb-contact-box{
    height: 2.4rem;
    right: .5rem;
    bottom: 6.7rem;
    z-index: 2005;
  }
  .contact-btn{
    width: 2.4rem;
    height: 2.4rem;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0rem .3rem .65rem 0rem rgba(0, 0, 0, 0.08);
    // position: fixed;
    // right: .5rem;
    // bottom: 6.7rem;
    // z-index: 3;
    // border-radius: 50%;
    // cursor: pointer;
    @include flex();
  }
  .icon-earphone{
    @include sc(1.6rem, $base-color);
  }
  .pc-contact-btn{
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    .contact-txt{
      font-size: .5rem;
      color: #222;
      display: inline-block;
      margin-top: .2rem;
      
    }
  }
  // 弹窗
  .contact-popup{
    width: 100%;
    background: $base-color;
    border-radius: .8rem .8rem 0rem 0rem;
  }
  .modal{
    width: 100%;
    padding: 2rem 0 6.3rem;
    background: $base-color;
    border-radius: .8rem .8rem 0rem 0rem;
    text-align: center;
    .circle-ring{
      width: 6.75rem;
      height: 6.7rem;
      margin: 0 auto;
      border: .3rem solid #5DC7D7;
      border-radius: 50%;
      @include flex();
    }
    .circle-bg{
      width: 5.1rem;
      height: 5.1rem;
      background: #FFFFFF;
      box-shadow: 0rem .1rem .25rem 0rem rgba(0, 0, 0, 0.2);
      border-radius: 50%;
      @include flex();
    }
    h3{
      margin: .4rem 0 .25rem;
      font-size: 1.2rem;
      color: #FFFFFF;
    }
    .wechat-num{
      font-size: .7rem;
      color: #fff;
      font-weight: 300;
    }
    .prompt-msg{
      margin: .65rem 0 1.9rem;
      font-size: .8rem;
      font-family: " HannotateSC-W7, HannotateSC";
      color: #FFFFFF;
    }
    .operation-btn{
      width: 11.75rem;
      margin: 0 auto;
      @include flex(space-between);
    }
    .btn{
      .icon-txt{
        display: inline-block;
        margin-top: .9rem;
        font-size: .7rem;
        color: #fff;
      }
    }
    .copy-btn{
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      background: #FFFFFF;
      @include flex();
      .icon{
        width: 1.4rem;
        height: 1.4rem;
      }
    }
  }
}
@media screen and (min-width:750px){
  .contact-box{
    width: 48px;
    position: fixed;
  }
  .pc-contact-box{
    // width: 302px;
    height: 122px;
    top: 60px;
    right: 80px;
    z-index: 5;
  }
  .mb-contact-box{
    height: 48px;
    right: 10px;
    bottom: 134px;
    z-index: 2005;
  }
  .contact-btn{
    width: 48px;
    height: 48px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0px 6px 13px 0px rgba(0, 0, 0, 0.08);
    // position: fixed;
    // right: 10px;
    // bottom: 134px;
    // z-index: 3;
    // border-radius: 50%;
    // cursor: pointer;
    @include flex();
  }
  .icon-earphone{
    @include sc(32px, $base-color);
  }
  .pc-contact-btn{
    width: 48px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    text-align: center;
    .contact-txt{
      font-size: 10px;
      color: #222;
      display: inline-block;
      margin-top: 4px;
      
    }
  }
  // 弹窗
  .contact-popup{
    width: 100%;
    background: $base-color;
    border-radius: 16px 16px 0px 0px;
  }
  .modal{
    width: 100%;
    padding: 40px 0 126px;
    background: $base-color;
    border-radius: 16px 16px 0px 0px;
    text-align: center;
    .circle-ring{
      width: 135px;
      height: 134px;
      margin: 0 auto;
      border: 6px solid #5DC7D7;
      border-radius: 50%;
      @include flex();
    }
    .circle-bg{
      width: 102px;
      height: 102px;
      background: #FFFFFF;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
      border-radius: 50%;
      @include flex();
    }
    h3{
      margin: 8px 0 5px;
      font-size: 24px;
      color: #FFFFFF;
    }
    .wechat-num{
      font-size: 14px;
      color: #fff;
      font-weight: 300;
    }
    .prompt-msg{
      margin: 13px 0 38px;
      font-size: 16px;
      font-family: " HannotateSC-W7, HannotateSC";
      color: #FFFFFF;
    }
    .operation-btn{
      width: 235px;
      margin: 0 auto;
      @include flex(space-between);
    }
    .btn{
      .icon-txt{
        display: inline-block;
        margin-top: 18px;
        font-size: 14px;
        color: #fff;
      }
    }
    .copy-btn{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: #FFFFFF;
      @include flex();
      .icon{
        width: 28px;
        height: 28px;
      }
    }
  }
  // pc
  .contact-modal{
    width: 230px;
    background: #FFFFFF;
    box-shadow: 0px 6px 14px 0px rgba(0, 0, 0, 0.1), inset 0px 0px 0px 0px #DDDDDD;
    border-radius: 16px;
    position: absolute;
    top: 0;
    right: 72px;
    z-index: 5;
    cursor: pointer;
    .m-row{
      width: 230px;
      height: 60px;
      padding: 0 16px;
      box-sizing: border-box;
      @include flex(space-between);
      &:first-child{
        border-bottom: 1px solid #ddd;
      }
      .info{
        font-size: 14px;
        color: #222;
        text-align: left;
      }
      .copy-btn{
        font-size: 14px;
        color: $base-color;
        text-align: right;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ContactButton.vue